<template>
  <v-sheet class="px-8 py-4">
    <v-container>
      <v-form
        autocomplete="off"
        ref="form"
        v-model="valid"
        :lazy-validation="true"
      >
        <v-row>
          <v-col class="px-6">
            <h1 class="primary--text">Operazione</h1>
            <v-simple-table class="my-4">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th
                      class="text-center red--text subtitle-2"
                      v-if="model != null && (model.cost || isRepair)"
                    >Costo</th>
                    <th
                      class="text-center red--text subtitle-2"
                      v-if="getNewReplacementsValue !== 0"
                    >Ricambi</th>
                    <th
                      class="text-center red--text subtitle-2"
                      v-if="getNewAccessoriesValue !== 0"
                    >Accessori</th>
                    <th
                      class="text-center red--text subtitle-2"
                      v-if="isDilapay"
                    >Dilapay</th>
                    <th
                      class="text-center red--text subtitle-2"
                      v-if="isPos"
                    >Pos</th>
                    <th class="text-center red--text subtitle-2">IVA</th>
                    <th class="text-center green--text subtitle-2">Utile</th>
                    <th
                      class="text-center blue--text subtitle-2"
                      v-if="isSim"
                    >Prezzo di Vendita</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td
                      class="text-center"
                      v-if="model != null && (model.cost || isRepair)"
                    >{{ `${parseFloat(newOperationCost).toFixed(2)}€`}}</td>
                    <td
                      class="text-center"
                      v-if="getNewReplacementsValue !== 0"
                    >{{ `${getNewReplacementsValue}€`}}</td>
                    <td
                      class="text-center"
                      v-if="getNewAccessoriesValue !== 0"
                    >{{ `${getNewAccessoriesValue}€`}}</td>
                    <td
                      class="text-center"
                      v-if="isDilapay"
                    >{{`${newOperationDilapay}€`}}</td>
                    <td
                      class="text-center"
                      v-if="isPos"
                    >{{`${newOperationPos}€`}}</td>
                    <td class="text-center">{{ `${newOperationVat}€`}}</td>
                    <td class="text-center">{{ `${newOperationGain}€` }}</td>
                    <td
                      class="text-center"
                      v-if="isSim"
                    >{{ `${(simSellingPrice)}€` }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="newOperationDate"
                  label="Data"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="newOperationDate"
                no-title
                scrollable
                actions
                locale="it-IT"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >Annulla</v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >OK</v-btn>
              </v-date-picker>
            </v-menu>

            <v-autocomplete
              :items="types"
              label="Tipologia"
              v-model="newOperationKind"
              :rules="[rules.required]"
            ></v-autocomplete>

            <v-autocomplete
              v-model="model"
              :items="searchItems"
              :loading="isLoading"
              :search-input.sync="search"
              hide-no-data
              hide-selected
              item-text="description"
              item-value="id"
              label="Articolo"
              return-object
              v-if="searchDbTable && !isFisso"
              :rules="[rules.required]"
            ></v-autocomplete>

            <v-row v-if="isRicarica">
              <v-col>
                <v-select
                  :items="gestoriMobile"
                  label="Gestore"
                  :rules="[rules.required]"
                  v-model="newOperationOperatorFrom"
                ></v-select>
              </v-col>
            </v-row>

            <v-row v-if="isContratto">

              <v-col v-if="isFisso">
                <v-select
                  :items="gestoriFisso"
                  item-text="title"
                  item-value="title"
                  label="Gestore"
                  :rules="[rules.required]"
                  v-if="isFisso"
                  v-model="newOperationOperatorTo"
                ></v-select>
              </v-col>

              <v-col v-if="isPortabilita">
                <v-select
                  :items="gestoriProvenienzaMobile"
                  label="Gestore di provenienza"
                  v-if="isSim"
                  :rules="[rules.required]"
                  v-model="newOperationOperatorFrom"
                ></v-select>
                <v-select
                  :items="gestoriProvenienzaFisso"
                  label="Gestore di provenienza"
                  v-if="isFisso"
                  :rules="[rules.required]"
                  v-model="newOperationOperatorFrom"
                ></v-select>
              </v-col>

              <v-col>
                <v-text-field
                  label="Nome offerta"
                  :rules="[rules.required]"
                  v-model="newOperationOfferName"
                ></v-text-field>
              </v-col>

              <v-col>
                <v-select
                  :items="simPayments"
                  label="Pagamento"
                  v-model="newOperationPaymentKind"
                  v-if="isSim"
                  :rules="[rules.required]"
                ></v-select>
                <v-select
                  :items="fissoPayments"
                  label="Pagamento"
                  v-model="newOperationPaymentKind"
                  v-else-if="isFisso"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>

              <v-col>
                <v-select
                  :items="tipologieContratto"
                  label="Tipologia contratto"
                  :rules="[rules.required]"
                  v-model="newOperationContractKind"
                ></v-select>
              </v-col>

              <v-col
                v-if="isPortabilita && isSim"
                style="display:flex; justify-content: center;"
              >
                <v-switch
                  color="primary"
                  label="Triangolazione"
                  v-model="newOperationDumping"
                ></v-switch>
              </v-col>

            </v-row>

            <v-row>
              <v-col>
                <v-select
                  :items="smartphonePayments"
                  label="Metodo di Pagamento"
                  v-model="newOperationPayment"
                  v-if="isSmartphone"
                  :rules="[rules.required]"
                ></v-select>
                <v-select
                  :items="payments"
                  label="Metodo di Pagamento"
                  v-model="newOperationPayment"
                  :rules="[rules.required]"
                  v-else
                ></v-select>
              </v-col>
              <v-col v-if="isPos">
                <v-select
                  :items="posSpecification"
                  label="Tipologia Pos"
                  v-model="newOperationPosKind"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  label="Prezzo Sim"
                  v-model="newOperationPrice"
                  type="number"
                  :rules="[rules.required]"
                  v-if="isSim"
                ></v-text-field>

                <v-text-field
                  label="Prezzo"
                  v-model="newOperationPrice"
                  type="number"
                  :rules="[rules.required]"
                  :disabled="newOperationGift"
                  v-else
                ></v-text-field>
              </v-col>
              <v-col v-if="isSim">
                <v-text-field
                  label="Costo Attivazione"
                  v-model="newOperationActivation"
                  type="number"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- dilapay specific -->
            <v-row>
              <v-col v-if="isDilapay || isSantander">
                <v-text-field
                  label="Rate"
                  v-model="newOperationRates"
                  type="number"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col v-if="(isDilapay || isSantander) && isAdvance">
                <v-text-field
                  label="Anticipo"
                  v-model="newOperationAdvance"
                  type="number"
                  :rules="[rules.required]"
                ></v-text-field>

              </v-col>
            </v-row>

            <v-flex>
              <v-row>
                <v-col>
                  <v-switch
                    v-model="newOperationCoffee"
                    inset
                    color="primary"
                    class="ml-2"
                  >
                    <template v-slot:prepend>
                      <v-icon class="mr-2">mdi-coffee</v-icon>
                    </template>
                    <template v-slot:append>
                      <span
                        style="font-weight: bold"
                        class="mt-1 mr-1"
                      >Caffè</span>
                    </template>
                  </v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="newOperationGift"
                    inset
                    color="primary"
                    class="ml-2"
                  >
                    <template v-slot:prepend>
                      <v-icon class="mr-2">mdi-gift</v-icon>
                    </template>
                    <template v-slot:append>
                      <span
                        style="font-weight: bold"
                        class="mt-1 mr-1"
                      >Omaggio</span>
                    </template>
                  </v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="newOperationPointsSh"
                    inset
                    color="primary"
                    class="ml-2"
                  >
                    <template v-slot:prepend>
                      <v-icon class="mr-2">mdi-wallet-giftcard</v-icon>
                    </template>
                    <template v-slot:append>
                      <span
                        style="font-weight: bold"
                        class="mt-1 mr-1"
                      >Punti SH</span>
                    </template>
                  </v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="newOperationInvoice"
                    inset
                    color="primary"
                    class="ml-2"
                  >
                    <template v-slot:prepend>
                      <v-icon class="mr-2">mdi-file</v-icon>
                    </template>
                    <template v-slot:append>
                      <span
                        style="font-weight: bold"
                        class="mt-1 mr-1"
                      >Fattura</span>
                    </template>
                  </v-switch>
                </v-col>
                <v-col>
                  <v-switch
                    v-model="newOperationB2b"
                    inset
                    color="primary"
                    class="ml-2"
                  >
                    <template v-slot:prepend>
                      <v-icon class="mr-2">mdi-cash-multiple</v-icon>
                    </template>
                    <template v-slot:append>
                      <span
                        style="font-weight: bold"
                        class="mt-1 mr-1"
                      >B2B</span>
                    </template>
                  </v-switch>
                </v-col>
              </v-row>
            </v-flex>
          </v-col>
          <v-col
            cols="12"
            mad="6"
            lg="4"
            v-if="this.newOperationReplacements"
            class="d-flex flex-column justify-between px-6"
          >
            <v-flex>
              <v-row>
                <v-col>
                  <h1 class="primary--text">Ricambi</h1>
                  <br>
                  <ul>
                    <li
                      :key="index"
                      v-for="(replacement, index) in smartphoneReplacements"
                    >
                      {{replacement}}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-flex>
            <v-flex v-if="searchDbTable != 'repairs'">
              <v-row>
                <v-col>
                  <h1 class="primary--text">Accessori</h1>
                  <br>
                  <ul>
                    <li
                      :key="index"
                      v-for="(accessory, index) in smartphoneAccessories"
                    >
                      {{accessory}}
                    </li>
                  </ul>
                </v-col>
              </v-row>
            </v-flex>
          </v-col>
        </v-row>
      </v-form>
      <v-row
        cols="12"
        class="pt-8"
      >
        <v-btn
          color="primary"
          class="mr-4"
          @click="formSubmit"
        >Salva operazione</v-btn>
        <v-btn
          color="orange darken-3"
          class="white--text"
          @click="formReset"
        >Reset</v-btn>
      </v-row>
    </v-container>
    <snack-notification :snack="snack" />
  </v-sheet>
</template>

<script>
  import axios from 'axios'

  import { mapGetters, mapMutations } from 'vuex'

  import SnackNotification from './../SnackNotification'
  import { accounting } from './../../mixins/accounting'

  import FASTWEB_CONFIG from './../../config/mapping_sim_fastweb'

  export default {
    name: 'NewOperationForm',
    mixins: [accounting],
    components: {
      SnackNotification
    },
    data() {
      return {
        valid: false,
        menu: false,
        isLoading: false,
        model: null,
        search: '',
        searchItems: [],
        searchDbTable: '',
        types: [
          { header: 'Prodotti' },
          'Smartphone Nuovo',
          'Smartphone Usato Art.17',
          'Smartphone Usato Art.36',
          'Accessorio',
          { divider: true },
          { header: 'Servizi Mobile' },
          'Ricarica Telefonica',
          'Attivazione SIM',
          'Portabilità SIM',
          { divider: true },
          { header: 'Servizi Fisso' },
          'Attivazione Fisso',
          'Portabilità Fisso',
          { divider: true },
          { header: 'Altro' },
          'Riparazione',
          'Servizio',
          'Formazione',
        ],
        payments: [
          'Cash',
          'Pos',
          'Assegno',
          'Bonifico',
          'Santander'
        ],
        smartphonePayments: [
          'Cash',
          'Pos',
          'Assegno',
          'Bonifico',
          'Santander',
          'Dilapay',
          'Dilapay + Anticipo Cash',
          'Dilapay + Anticipo Pos',
          'Dilapay + Anticipo Bonifico',
          'Dilapay + Anticipo Assegno',
          'Rateizzazione Tim',
          'Rateizzazione Vodafone'
        ],
        simPayments: [
          'Credito Residuo',
          'Domiciliazione'
        ],
        fissoPayments: [
          'Bollettino',
          'Domiciliazione'
        ],
        posSpecification: [
          'Bancomat',
          'Carta di Credito'
        ],
        form: {
          ricambi: true,
          caffe: false
        },
        gestoriMobile: [
          'Tim',
          'Vodafone',
          'Fastweb',
          'Tiscali',
          'Eolo',
          'Kena Mobile',
          'Ho. Mobile',
          'Lyca Mobile'
        ],
        gestoriFisso: [],
        gestoriProvenienzaMobile: [
          'Tim',
          'Wind',
          'Tre',
          'Vodafone',
          'Iliad',
          'Kena Mobile',
          'Fastweb Full',
          'Fastweb Pre',
          'Ho. Mobile',
          'Poste Mobile Full',
          'Poste Mobile Pre',
          'Coop Voce',
          'BT Italia Ful',
          'Daily Telecom',
          'Digi Mobil',
          'Digitel',
          'Foll-In',
          'Green Telecomunicazioni',
          'Lyca Mobile',
          'MUND_GSM',
          'NT Mobile Full',
          'NT Mobile Pre',
          'NV Mobile',
          'Noitel Full',
          'Noitel Pre',
          'Optima',
          'Plintron',
          'Rabona Mobile Full',
          'Rabona Mobile Pre',
          'Tiscali',
          'UnoMobile - Carrefour',
          'Welcome Italia',
          'Whitu',
          'Altro'
        ],
        gestoriProvenienzaFisso: [
          'Tim',
          'Vodafone',
          'Fastweb',
          'Wind - Infostrada',
          'TeleTu',
          'Tiscali',
          'Eolo',
          'Altro',
        ],
        tipologieContratto: [
          'Consumer',
          'Business'
        ],
        snack: {
          error: null,
          visible: null,
          message: null
        },
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          fastweb: FASTWEB_CONFIG
        },
        apiConfig: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        },
      }
    },
    computed: {
      ...mapGetters([
        'getNewOperation',
        'getNewReplacements',
        'getNewReplacementsValue',
        'getNewAccessories',
        'getNewAccessoriesValue'
      ]),
      newOperationDate: {
        get() {
          return this.getNewOperation.date
        },
        set(value) {
          if (value) {
            this.SET_NEW_OPERATION_DATE(value)
          }
        }
      },
      newOperationKind: {
        get() {
          return this.getNewOperation.kind
        },
        set(value) {

          this.formReset()
          this.RESET_NEW_OPERATION()

          this.SET_NEW_OPERATION_KIND(value)

          if (this.isSmartphone) {
            this.searchDbTable = 'smartphones'

            if (this.isUsato) {
              this.SET_NEW_OPERATION_REPLACEMENTS(true)

            } else {

              this.SET_NEW_OPERATION_REPLACEMENTS(false)
            }

          } else if (this.isAccessory) {
            this.searchDbTable = 'accessories'

            this.SET_NEW_OPERATION_REPLACEMENTS(false)

          } else if (this.isService) {
            this.searchDbTable = 'services'

            this.SET_NEW_OPERATION_REPLACEMENTS(false)

          } else if (this.isRepair) {
            this.searchDbTable = 'repairs'

            this.SET_NEW_OPERATION_REPLACEMENTS(true)

          } else if (this.isLesson) {
            this.searchDbTable = 'lessons'

            this.SET_NEW_OPERATION_REPLACEMENTS(false)

          } else if (this.isSim) {
            this.searchDbTable = 'sims'

            this.SET_NEW_OPERATION_REPLACEMENTS(false)

          } else if (this.isFisso) {
            this.searchDbTable = 'fisso'

            this.SET_NEW_OPERATION_REPLACEMENTS(false)

          } else {
            this.searchDbTable = ''
          }

          if (!this.isDilationable) {
            this.SET_NEW_OPERATION_DILAPAY(0)
            this.SET_NEW_OPERATION_RATES('')
            this.SET_NEW_OPERATION_ADVANCE('')
            this.SET_NEW_OPERATION_PAYMENT('')
          }

          this.model = null
          this.search = ''
          this.searchItems = []

          this.propagateChanges()
        }
      },
      newOperationPayment: {
        get() {
          return this.getNewOperation.payment
        },
        set(value) {

          this.SET_NEW_OPERATION_PAYMENT(value)

          if (!this.isDilapay) {
            this.SET_NEW_OPERATION_RATES('')
            this.SET_NEW_OPERATION_DILAPAY(0)
          }

          if (!this.isSantander) {
            this.SET_NEW_OPERATION_RATES('')
          }

          if (!this.isAdvance) {
            this.SET_NEW_OPERATION_ADVANCE('')
          }

          if (!this.isPos) {
            this.SET_NEW_OPERATION_POS_KIND('')
            this.SET_NEW_OPERATION_POS(0)
          }

          if (this.isOperator) {
            this.SET_NEW_OPERATION_PRICE(this.getNewOperation.cost)
          }

          if (this.isSmartphone) {
          }

          else {
            this.SET_NEW_OPERATION_PRICE(this.model.price)
          }

          this.propagateChanges()
        }
      },
      newOperationPosKind: {
        get() {
          return this.getNewOperation.posKind
        },
        set(value) {

          this.SET_NEW_OPERATION_POS_KIND(value)
          this.propagateChanges()
        }
      },
      newOperationName: {
        get() {
          return this.getNewOperation.name
        },
        set(value) {
          this.SET_NEW_OPERATION_NAME(value)
        }
      },
      newOperationCost: {
        get() {
          return this.getNewOperation.cost
        },
        set(value) {

          this.SET_NEW_OPERATION_COST(value)
          this.propagateChanges()
        }
      },
      newOperationPrice: {
        get() {
          return this.getNewOperation.price
        },
        set(value) {

          this.SET_NEW_OPERATION_PRICE(value)
          this.propagateChanges()
        }
      },
      newOperationActivation: {
        get() {
          return this.getNewOperation.activation
        },
        set(value) {

          this.SET_NEW_OPERATION_ACTIVATION(value)
          this.propagateChanges()
        }
      },
      newOperationRates: {
        get() {
          return this.getNewOperation.rates
        },
        set(value) {

          this.SET_NEW_OPERATION_RATES(value)
          this.propagateChanges()
        }
      },
      newOperationAdvance: {
        get() {
          return this.getNewOperation.advance
        },
        set(value) {

          this.SET_NEW_OPERATION_ADVANCE(value)
          this.propagateChanges()
        }
      },
      newOperationOperatorFrom: {
        get() {
          return this.getNewOperation.operatorFrom
        },
        set(value) {

          this.SET_NEW_OPERATION_OPERATOR_FROM(value)
          this.propagateChanges()
        }
      },
      newOperationOperatorTo: {
        get() {
          return this.getNewOperation.operatorTo
        },
        set(value) {

          this.SET_NEW_OPERATION_OPERATOR_TO(value)
          this.propagateChanges()
        }
      },
      newOperationOfferName: {
        get() {
          return this.getNewOperation.offerName
        },
        set(value) {

          this.SET_NEW_OPERATION_OFFER_NAME(value)
          this.propagateChanges()
        }
      },
      newOperationPaymentKind: {
        get() {
          return this.getNewOperation.paymentKind
        },
        set(value) {

          this.SET_NEW_OPERATION_PAYMENT_KIND(value)
          this.propagateChanges()
        }
      },
      newOperationContractKind: {
        get() {
          return this.getNewOperation.contractKind
        },
        set(value) {

          this.SET_NEW_OPERATION_CONTRACT_KIND(value)
          this.propagateChanges()
        }
      },
      newOperationDumping: {
        get() {
          return this.getNewOperation.dumping
        },
        set(value) {

          this.SET_NEW_OPERATION_DUMPING(value)
          this.propagateChanges()
        }
      },
      newOperationGain() {
        return this.getNewOperation.gain
      },
      newOperationVat() {
        return this.getNewOperation.vat
      },
      newOperationDilapay() {
        return this.getNewOperation.dilapay
      },
      newOperationPos() {
        return this.getNewOperation.pos
      },
      newOperationReplacements: {
        get() {
          return this.getNewOperation.replacements
        },
        set(value) {
          this.SET_NEW_OPERATION_REPLACEMENTS(value)
        }
      },
      newOperationCoffee: {
        get() {
          return this.getNewOperation.coffee
        },
        set(value) {

          this.SET_NEW_OPERATION_COFFEE(value)
          this.propagateChanges()
        },
      },
      newOperationGift: {
        get() {
          return this.getNewOperation.gift
        },
        set(value) {

          if (value) {

            this.newOperationPointsSh = false
            this.newOperationPrice = "0"
          } else {

            if (this.model && this.model.price) {

              this.newOperationPrice = this.model.price
            } else {

              this.newOperationPrice = null
            }
          }

          this.SET_NEW_OPERATION_GIFT(value)
          this.propagateChanges()
        },
      },
      newOperationPointsSh: {
        get() {
          return this.getNewOperation.pointsSh
        },
        set(value) {

          if (value) {

            this.newOperationGift = false

            if (this.model && this.model.price) {

              this.newOperationPrice = this.model.price
            } else {

              this.newOperationPrice = null
            }
          }

          this.SET_NEW_OPERATION_POINTS_SH(value)
          this.propagateChanges()
        },
      },
      newOperationInvoice: {
        get() {
          return this.getNewOperation.invoice
        },
        set(value) {

          this.SET_NEW_OPERATION_INVOICE(value)
          this.propagateChanges()
        },
      },
      newOperationB2b: {
        get() {
          return this.getNewOperation.b2b
        },
        set(value) {

          this.SET_NEW_OPERATION_B2B(value)
          this.propagateChanges()
        },
      },
      isDilapay() {
        return this.newOperationPayment === 'Dilapay' ||
          this.newOperationPayment === 'Dilapay + Anticipo Cash' ||
          this.newOperationPayment === 'Dilapay + Anticipo Pos' ||
          this.newOperationPayment === 'Dilapay + Anticipo Bonifico' ||
          this.newOperationPayment === 'Dilapay + Anticipo Assegno'
      },
      isAdvance() {
        return this.newOperationPayment === 'Santander' ||
          this.newOperationPayment === 'Dilapay + Anticipo Cash' ||
          this.newOperationPayment === 'Dilapay + Anticipo Pos' ||
          this.newOperationPayment === 'Dilapay + Anticipo Bonifico' ||
          this.newOperationPayment === 'Dilapay + Anticipo Assegno'
      },
      isOperator() {
        return this.newOperationPayment === 'Rateizzazione Tim' ||
          this.newOperationPayment === 'Rateizzazione Vodafone'
      },
      isDilationable() {
        return this.newOperationKind === 'Smartphone Nuovo' ||
          this.newOperationKind === 'Smartphone Usato Art.17' ||
          this.newOperationKind === 'Smartphone Usato Art.36'
      },
      isSantander() {
        return this.newOperationPayment === 'Santander'
      },
      isPos() {
        return this.newOperationPayment === 'Pos' ||
          this.newOperationPayment === 'Dilapay + Anticipo Pos'
      },
      isSmartphone() {
        return this.newOperationKind === 'Smartphone Nuovo' ||
          this.newOperationKind === 'Smartphone Usato Art.17' ||
          this.newOperationKind === 'Smartphone Usato Art.36'
      },
      isUsato() {
        return this.newOperationKind === 'Smartphone Usato Art.17' ||
          this.newOperationKind === 'Smartphone Usato Art.36'
      },
      isArt17() {
        return this.newOperationKind === 'Smartphone Nuovo' ||
          this.newOperationKind === 'Smartphone Usato Art.17'
      },
      isAccessory() {
        return this.newOperationKind === 'Accessorio'
      },
      isService() {
        return this.newOperationKind === 'Servizio'
      },
      isRepair() {
        return this.newOperationKind === 'Riparazione'
      },
      isLesson() {
        return this.newOperationKind === 'Formazione'
      },
      isSim() {
        return this.newOperationKind === 'Attivazione SIM' ||
          this.newOperationKind === 'Portabilità SIM'
      },
      isFisso() {
        return this.newOperationKind === 'Attivazione Fisso' ||
          this.newOperationKind === 'Portabilità Fisso'
      },
      isAttivazione() {
        return this.newOperationKind === 'Attivazione SIM' ||
          this.newOperationKind === 'Attivazione Fisso'
      },
      isPortabilita() {
        return this.newOperationKind === 'Portabilità SIM' ||
          this.newOperationKind === 'Portabilità Fisso'
      },
      isContratto() {
        return this.newOperationKind === 'Attivazione SIM' ||
          this.newOperationKind === 'Attivazione Fisso' ||
          this.newOperationKind === 'Portabilità SIM' ||
          this.newOperationKind === 'Portabilità Fisso'

      },
      isRicarica() {
        return this.newOperationKind === 'Ricarica Telefonica'
      },
      smartphoneReplacements() {
        if (!this.model) return ['Nessun articolo selezionato.']

        if (this.model.replacements.length === 0) {
          return ['Nessuna componente sostituita.']
        } else {
          return this.model.replacements.map(el => {
            return `${el.name} ${el.model} ${el.state} ${el.color || ''}, ${el.cost}€`
          })
        }
      },
      smartphoneAccessories() {
        if (!this.model) return ['Nessun articolo selezionato.']

        if (this.model.accessories.length === 0) {
          return ['Nessun accessorio abbinato.']
        } else {
          console.log(this.model.accessories)
          return this.model.accessories.map(el => {
            return `${el.model} ${el.color || ''} ${el.desctiption || ''}, ${el.cost}€`
          })
        }
      },
      simSellingPrice() {
        const price = parseFloat(this.newOperationPrice) || 0.00
        const activation = parseFloat(this.newOperationActivation) || 0.00
        return (price + activation)
      }
    },
    methods: {
      ...mapMutations([
        'SET_NEW_OPERATION_DATE',
        'SET_NEW_OPERATION_KIND',
        'SET_NEW_OPERATION_PAYMENT',
        'SET_NEW_OPERATION_POS_KIND',
        'SET_NEW_OPERATION_NAME',
        'SET_NEW_OPERATION_COST',
        'SET_NEW_OPERATION_ACTIVATION',
        'SET_NEW_OPERATION_PRICE',
        'SET_NEW_OPERATION_RATES',
        'SET_NEW_OPERATION_ADVANCE',

        'SET_NEW_OPERATION_GAIN',
        'SET_NEW_OPERATION_VAT',

        'SET_NEW_OPERATION_DILAPAY',
        'SET_NEW_OPERATION_POS',

        'SET_NEW_OPERATION_REPLACEMENTS',
        'SET_NEW_OPERATION_COFFEE',
        'SET_NEW_OPERATION_GIFT',
        'SET_NEW_OPERATION_POINTS_SH',
        'SET_NEW_OPERATION_INVOICE',
        'SET_NEW_OPERATION_B2B',

        'SET_NEW_OPERATION_OPERATOR_FROM',
        'SET_NEW_OPERATION_OPERATOR_TO',
        'SET_NEW_OPERATION_OFFER_NAME',
        'SET_NEW_OPERATION_PAYMENT_KIND',
        'SET_NEW_OPERATION_CONTRACT_KIND',
        'SET_NEW_OPERATION_DUMPING',

        'RESET_NEW_OPERATION'
      ]),
      async fetchOperatoriTelefoniaFissa() {
        try {
          let { data } = await axios.post(
            `${process.env.VUE_APP_API}/categories/by-reference`,
            { reference: 'operatori telefonia fissa' },
            this.apiConfig
          )

          this.gestoriFisso = data
        } catch (error) {
          console.log(error)

          this.gestoriFisso = []
        }
      },
      propagateChanges() {
        let cost

        if (this.isRepair && this.model) {

          let replacementsCost =
            this.model.replacements.length === 0
              ? 0
              : this.model.replacements
                .map(el => {
                  return parseFloat(el.cost)
                })
                .reduce((accumulator, currentValue) => {
                  return parseFloat(accumulator) + parseFloat(currentValue)
                })

          cost = replacementsCost

        } else if (this.isService || this.isLesson) {

          cost = "0"
        } else if (this.isUsato) {

          let smartphoneCost = this.model ? this.model.cost : false

          if (smartphoneCost) {

            let replacementsCost =
              this.model.replacements.length === 0
                ? 0
                : this.model.replacements
                  .map(el => {
                    return parseFloat(el.cost)
                  })
                  .reduce((accumulator, currentValue) => {
                    return parseFloat(accumulator) + parseFloat(currentValue)
                  })

            let accessoriesCost =
              this.model.accessories.length === 0
                ? 0
                : this.model.accessories
                  .map(el => {
                    return parseFloat(el.cost)
                  })
                  .reduce((accumulator, currentValue) => {
                    return parseFloat(accumulator) + parseFloat(currentValue)
                  })

            cost = smartphoneCost + replacementsCost + accessoriesCost
          } else {

            cost = false
          }
        } else {

          cost = this.model ? this.model.cost : false
        }

        const price = this.getNewOperation.price || '0'
        const kind = this.getNewOperation.kind

        const coffee = this.getNewOperation.coffee ? 1 : 0

        const rates = this.getNewOperation.rates || 1
        const advance = this.getNewOperation.advance || 0

        let isFastweb = false
        let mapping = null

        let vat
        let gain

        console.log(this.getNewOperation.activation)

        if (this.model && this.model.brand) {
          isFastweb = this.model.brand.toUpperCase() === 'FASTWEB'

          if (isFastweb) {

            mapping = FASTWEB_CONFIG.map(el => {

              if (el.tipologia == this.newOperationKind && el.pagamento == this.newOperationPaymentKind) return el
            }).filter(el => el != null)

            if (this.getNewOperation.activation === 0) {
              this.SET_NEW_OPERATION_ACTIVATION(mapping[0].prezzo)
            }

            gain = (parseFloat(mapping[0].prezzo) + parseFloat(this.getNewOperation.price || 0) - parseFloat(mapping[0].commissione)).toFixed(2)

          }
        }

        if (cost && price && kind || price && kind && isFastweb) {

          const position = this.types.indexOf(kind)
          const margin = this.newOperationKind === 'Smartphone Usato Art.36' || this.isSim ? true : false
          let extra

          if (this.isRepair) {
            extra = parseFloat(coffee)
          } else {
            extra = parseFloat(this.getNewReplacementsValue) + parseFloat(this.getNewAccessoriesValue) + parseFloat(coffee)
          }

          // add Dilapay to extra costs
          if (this.isDilapay) {

            let dilapay = 0

            if (this.isAdvance) {
              dilapay = this._calculateDilapayCost(price, rates, advance)
            } else {
              dilapay = this._calculateDilapayCost(price, rates)
            }

            extra = parseFloat(extra) + parseFloat(dilapay)

            this.SET_NEW_OPERATION_DILAPAY(dilapay)
          }

          // add pos fees to extra costs
          if (this.isPos && this.getNewOperation.posKind) {

            let pos = this._calculatePosCost(price, this.getNewOperation.posKind)

            extra = parseFloat(extra) + parseFloat(pos)

            this.SET_NEW_OPERATION_POS(pos)
          }

          // VAT

          if (this.isSim || this.newOperationB2b && this.isArt17 || this.isOperator || this.isRicarica) {

            vat = 0.00
          } else {

            vat = this._calculateVat(cost, price, margin).toFixed(2)
          }

          // GAIN

          console.log('mapping', mapping)

          if (mapping === null) {
            gain = this._calculateGain(cost, price, vat, extra).toFixed(2)
          }

          this.SET_NEW_OPERATION_VAT(vat)
          this.SET_NEW_OPERATION_GAIN(gain)
        }
      },

      async formSubmit() {
        const config = {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        }

        if (this.$refs.form.validate()) {

          const body = {
            operation: this.getNewOperation,
            article: this.model,
            user: localStorage.getItem('username')
          }

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })

          const { data } = await axios.post(`${process.env.VUE_APP_API}/operations/create`, body, config)

          if (data.status) {

            this.snack = Object.assign({}, {
              visible: true,
              error: false,
              message: 'Operazione salvata correttamente!'
            })

            this.RESET_NEW_OPERATION()
            this.model = null
            this.searchDbTable = null
            this.$refs.form.resetValidation()
            this.$emit('update-operations')
          } else {

            this.snack = Object.assign({}, {
              visible: true,
              error: true,
              message: 'Errore nel salvataggio.'
            })
          }
        }
      },
      formReset() {
        this.RESET_NEW_OPERATION()
      },
    },
    watch: {
      async search(term) {

        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        const config = {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        }
        if (!this.isFisso) {
          // Lazily load input items

          let body

          if (this.searchDbTable === 'smartphones') {

            const isNew = this.newOperationKind === 'Smartphone Nuovo' ? true : false
            const isArt17 = this.newOperationKind === 'Smartphone Nuovo' || this.newOperationKind === 'Smartphone Usato Art.17' ? true : false

            body = {
              term: term,
              isNew,
              isArt17
            }
          } else {

            body = {
              term: term
            }
          }

          const { data } = await axios.post(`${process.env.VUE_APP_API}/${this.searchDbTable}/search`, body, config)

          if (this.searchDbTable === 'smartphones') {

            this.searchItems = data.map(el => {
              return {
                id: el.id,
                cost: el.cost,
                price: el.price,
                description: `[${el.serial_number}] ${el.grade || 'Nuovo'} ${el.brand} ${el.model} ${el.color}, ${el.disk_space} / ${el.ram} | ${el.supplier_name}`,
                replacements: el.replacements,
                accessories: el.accessories
              }
            })
          } else if (this.searchDbTable === 'accessories') {

            this.searchItems = data.map(el => {
              return {
                id: el.id,
                cost: el.cost,
                price: el.price,
                description: `[${el.serial_code}] ${el.brand} ${el.model} ${el.color || ''} ${el.desctiption || ''} | ${el.supplier_name}`
              }
            })
          } else if (this.searchDbTable === 'services') {

            this.searchItems = data.map(el => {
              return {
                id: el.id,
                price: el.price,
                description: `${el.name}`
              }
            })
          } else if (this.searchDbTable === 'lessons') {

            this.searchItems = data.map(el => {
              return {
                id: el.id,
                price: el.price,
                description: `${el.name}`
              }
            })
          } else if (this.searchDbTable === 'repairs') {

            this.searchItems = data.map(el => {
              return {
                id: el.id,
                price: el.price,
                description: `${el.name} ${el.surename} | ${el.serial} ${el.brand} ${el.model} ${el.color}`,
                replacements: el.replacements
              }
            })
          } else if (this.searchDbTable === 'sims') {

            this.searchItems = data.map(el => {
              return {
                id: el.id,
                brand: el.brand,
                cost: el.cost,
                price: el.price,
                description: `${el.serial_number} ${el.brand} ${el.cost}€`
              }
            })
          }
        }

        this.isLoading = false


      },
      model(val) {
        if (val && val.cost) {

          if (this.isUsato) {
            let replacementsCost =
              this.model.replacements.length === 0
                ? 0
                : this.model.replacements
                  .map(el => {
                    return parseFloat(el.cost)
                  })
                  .reduce((accumulator, currentValue) => {
                    return parseFloat(accumulator) + parseFloat(currentValue)
                  })

            let accessoriesCost =
              this.model.accessories.length === 0
                ? 0
                : this.model.accessories
                  .map(el => {
                    return parseFloat(el.cost)
                  })
                  .reduce((accumulator, currentValue) => {
                    return parseFloat(accumulator) + parseFloat(currentValue)
                  })

            this.newOperationCost = val.cost + replacementsCost + accessoriesCost

          } else {

            this.newOperationCost = val.cost
          }
        }

        if (val && this.isRepair) {
          let replacementsCost =
            this.model.replacements.length === 0
              ? 0
              : this.model.replacements
                .map(el => {
                  return parseFloat(el.cost)
                })
                .reduce((accumulator, currentValue) => {
                  return parseFloat(accumulator) + parseFloat(currentValue)
                })

          this.newOperationCost = replacementsCost
        }

        if (val && val.price && !this.newOperationGift) {
          console.log(this.newOperationGift)
          this.newOperationPrice = val.price
        }
      }
    },
    async created() {
      await this.fetchOperatoriTelefoniaFissa()
    }
  }
</script>